import React from "react";
import LoadingScreen from "../../../../../shared/components/LoadingScreen";
import AddProducts from "./AddProducts";
import EditProducts from "./EditProducts";
import ProductsToolbar from "./components/ProductsToolbar";
import ProductsTable from "./components/ProductsTable";
import DeleteConfirmModal from "./components/DeleteConfirmModal";
import { productHeaderCell, buildTableData } from "./components/ProductTableHelpers";
import { useProductsPage } from "./hooks/useProductsPage";

export default function Products({ usedPopup = false }: { usedPopup?: boolean }) {
  const {
    addProduct, setAddProduct,
    editProduct, setEditProduct,
    confirmDeleteList,
    deleted, setDeleted,
    isLoading, setLoading,
    filterCategory, setFilterCategory,
    page, rowsPerPage,
    showDropdown, setShowDropdown,
    product, loadingPro, productPage, category,
    searchTerm, setSearchTerm,
    createProduct, updateProduct,
    amountFormat,
    fileInputRef,
    handleClose, handleDelete, confirmDelete,
    handleExport, handleImportClick, handleImportFile,
    handlePageChange, handleRowsChange,
    setField, setOrderBy,
  } = useProductsPage(usedPopup);

  const tableData = buildTableData(product, page, rowsPerPage, amountFormat);

  return (
    <div className="w-full h-full overflow-auto bg-white rounded-2xl shadow m-1">

      <ProductsToolbar
        usedPopup={usedPopup}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        deleted={deleted}
        setDeleted={setDeleted}
        filterCategory={filterCategory}
        setFilterCategory={setFilterCategory}
        category={category}
        createProduct={createProduct}
        showDropdown={showDropdown}
        setShowDropdown={setShowDropdown}
        onAddProduct={() => setAddProduct(true)}
        onExport={handleExport}
        onImportClick={handleImportClick}
        onImportFile={handleImportFile}
        fileInputRef={fileInputRef}
      />

      <ProductsTable
        tableData={tableData}
        headCells={productHeaderCell}
        deleted={deleted}
        usedPopup={usedPopup}
        updateProduct={updateProduct}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={productPage?.totalRecords ?? 0}
        onPageChange={handlePageChange}
        onRowsChange={handleRowsChange}
        onDelete={handleDelete}
        onEdit={(id) => setEditProduct(product.find((p) => p._id.$oid === id))}
        onSort={(data) => { setField(data.field); setOrderBy(data.orderby); }}
        product={product}
      />

      {addProduct && (
        <AddProducts close={handleClose} category={category} loading={setLoading} addProduct={addProduct} />
      )}
      {editProduct && (
        <EditProducts editData={editProduct} close={handleClose} category={category} loading={setLoading} />
      )}
      {confirmDeleteList && (
        <DeleteConfirmModal
          names={confirmDeleteList}
          onCancel={handleClose}
          onConfirm={confirmDelete}
        />
      )}

      {(loadingPro || isLoading) && <LoadingScreen />}
    </div>
  );
}